import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import {
  FolderItem,
  IFolderMap,
  IProjectContext,
  IProjectMap,
  Projects
} from '../lib/models/interfaces';
import axios from 'axios';
import { UserContext } from './authContext';
import { useLocation } from 'react-router-dom';
import { DocumentContext } from './documentContext';
import { useAlert } from './alertContext';
interface Props {
  children?: ReactNode;
}
export const ProjectContext = createContext({} as IProjectContext);

export const ProjectContextProvider: React.FC<Props> = (props) => {
  const { auth, token } = useContext(UserContext);
  const { handleError, setAlert } = useAlert();
  // const { getAllDocs } = useContext(DocumentContext);
  const [mainProjects, setMainProjects] = useState<Projects[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<Projects[]>([]); // current selectedProject
  const [folderName, setFolderName] = useState<string>('');
  const [folderDescription, setFolderDescription] = useState<string>('');
  const [createFolderLoading, setCreateFolderLoading] =
    useState<boolean>(false);
  const [newFolderModalVisible, setNewFolderModalVisible] =
    useState<boolean>(false);
  const [selectedFolders, setSelectedFolder] = useState<FolderItem[]>([]); // currentSelected Folder
  const [projectIdContext, setProjectIdContext] = useState<string>('');
  const [allFolders, setAllFolders] = useState<FolderItem[]>([]);
  const [currentProjectFolders, setCurrentProjectFolders] = useState<
    FolderItem[]
  >([]);
  const [deleteLoadingFolder, setDeleteLoadingFolder] =
    useState<boolean>(false);
  const [projectMap, setProjectMap] = useState<IProjectMap>({} as IProjectMap);
  const [folderMap, setFolderMap] = useState<IFolderMap>({} as IFolderMap);
  const location = useLocation();

  const setSelection = () => {
    if (!projectIdContext) {
      setSelectedProjects([]);
    } else {
      const projectToSet = mainProjects.filter(
        (ele) => ele._id === projectIdContext
      );
      setSelectedProjects(projectToSet);
    }
  };
  const setProjects = () => {
    if (allFolders.length > 0 && selectedProjects.length > 0) {
      const currentFolders = allFolders.filter(
        (ele) => ele.project === selectedProjects[0]._id
      );
      setCurrentProjectFolders(currentFolders);
    }
  };
  useEffect(() => {
    setProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainProjects, allFolders, selectedProjects]);
  // useEffect(() => {
  //   if (!token) return;
  //   getAllProjects('startup');
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // useEffect(() => {
  //   getAllProjects('token change');
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token]);
  useEffect(() => {
    setSelection();
  }, [projectIdContext]);

  useEffect(() => {
    setSelection();
  }, [mainProjects]);

  useMemo(() => {
    const projectMapT: IProjectMap = {};
    const folderMapT: IFolderMap = {};
    if (mainProjects.length > 0) {
      mainProjects.forEach(
        (project) => (projectMapT[project._id] = project.projectName)
      );
      setProjectMap(projectMapT);
    }
    if (allFolders.length > 0) {
      allFolders.forEach(
        (folder) => (folderMapT[folder._id] = folder.folderName)
      );
      setFolderMap(folderMapT);
    }
  }, [mainProjects, allFolders]);

  const createNewFolder = async () => {
    setCreateFolderLoading(true);
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_KORU_API}/folder?type=newFolder`,
        {
          newFolder: {
            folderName: folderName,
            folderDescription: folderDescription,
            project: selectedProjects[0]._id
          }
        },
        auth
      );
      console.log('Added new folder', result);
      // getAllProjects('create new folder');
      // getAllDocs();
      setCreateFolderLoading(false);
      setNewFolderModalVisible(false);
      setFolderName('');
      setAlert('Folder Created', 'success', 2);
    } catch (e) {
      const error = e as Error;
      handleError(error);
      console.log('error', error.message);
    }
  };

  const updateFolder = async (id: string) => {
    setCreateFolderLoading(true);
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_KORU_API}/folder?type=update`,
        {
          updates: {
            folderName: folderName,
            folderDescription: folderDescription
          },
          _id: id
        },
        auth
      );
      // getAllProjects('update folder');
      // getAllDocs();
      setCreateFolderLoading(false);
      setNewFolderModalVisible(false);
      setFolderName('');
      setAlert('Folder Updated', 'success', 2);
    } catch (e) {
      const error = e as Error;
      handleError(error);
      console.log('error', error.message);
    }
  };

  const deleteFolder = async (id: string) => {
    try {
      setDeleteLoadingFolder(true);
      const result = await axios.post(
        `${process.env.REACT_APP_KORU_API}/folder?type=deleteFolder`,
        {
          _id: id
        },
        auth
      );
      // getAllDocs();
      setDeleteLoadingFolder(false);
      setAlert('Folder deleted', 'success', 2);
    } catch (e) {
      const error = e as Error;
      console.log('error', error.message);
      setDeleteLoadingFolder(false);
      handleError(error);
    }
  };

  const value = {
    mainProjects,
    setMainProjects,
    // getAllProjects,
    selectedProjects,
    setSelectedProjects,
    folderName,
    setFolderName,
    createNewFolder,
    createFolderLoading,
    updateFolder,
    newFolderModalVisible,
    setNewFolderModalVisible,
    deleteFolder,
    selectedFolders,
    setSelectedFolder,
    projectIdContext,
    setProjectIdContext,
    folderDescription,
    setFolderDescription,
    allFolders,
    setAllFolders,
    currentProjectFolders,
    setCurrentProjectFolders,
    deleteLoadingFolder,
    setDeleteLoadingFolder,
    folderMap,
    projectMap
  };

  return (
    <ProjectContext.Provider value={value}>
      {props.children}
    </ProjectContext.Provider>
  );
};
